import * as React from 'react';
import { HeaderContext, type IHeaderNavItemData } from '../../common';
import styles from './index.module.less';
import classNames from 'classnames';
import CompDropdownMenu from '../CompDropdownMenu';
import { ReoIcon } from '@reolink-web/components.basic';

interface INavItemProps extends IHeaderNavItemData {
    /**
     * @desc 下拉菜单宽度
     * @default 200
     */
    dropMenuWidth?: number;
    isShowSubMenu?: boolean;
    onTitleClick?: () => void;
}
const CompNavItem: React.FC<INavItemProps> = function(props: INavItemProps) {
    const { getTextByKey } = React.useContext(HeaderContext);
    return (
        <li
            className={ classNames(styles['nav-item'], {
                [styles['nav-with-menus']]: props.menus && props.menus.length > 0,
                [styles['show-sub-menu']]: props.isShowSubMenu,
            }) }
        >
            <a
                className={ styles['nav-item-title'] }
                // eslint-disable-next-line react/jsx-handler-names
                onClick={ props.menus?.length ? props.onTitleClick : undefined }
                href={ props.link }
                target="_blank"
                rel="noreferrer"
            >
                <span className={ styles['nav-item-title-text'] }>
                    {getTextByKey(props.title)}
                    {props.badge ? <div className={ styles['nav-item-badge'] } /> : null}
                </span>

                {props.menus?.length ? (
                    <ReoIcon
                        name={ props.isShowSubMenu ? 'icon-icon_cross2' : 'icon-icon_plus' }
                        className={ styles['nav-item-title-icon'] }
                    />
                ) : null}
            </a>
            {props.menus && props.menus.length > 0 ? (
                <CompDropdownMenu
                    className={ classNames(styles['dropdown-menu-content']) }
                    menus={ props.menus } />
            ) : null}
        </li>
    );
};
export default CompNavItem;
